"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var _validate = require("@/utils/validate");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'roleEdit',
  props: {
    isCreate: {
      type: Number,
      required: 0
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      expandAll: false,
      loading: false,
      pram: {
        roleName: null,
        rules: '',
        status: null,
        id: null,
        merId: JSON.parse(_jsCookie.default.get('JavaMerInfo')).id
      },
      menuExpand: false,
      menuNodeAll: false,
      menuOptions: [],
      menuCheckStrictly: true,
      currentNodeId: [],
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      menuIds: []
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.getCacheMenu();
  },
  methods: {
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      var _this = this;
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        roleName = _this$editData.roleName,
        status = _this$editData.status,
        id = _this$editData.id,
        merId = _this$editData.merId;
      this.pram.roleName = roleName;
      this.pram.status = status;
      this.pram.id = id;
      this.pram.merId = JSON.parse(_jsCookie.default.get('JavaMerInfo')).id;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      roleApi.getInfo(id).then(function (res) {
        _this.menuOptions = res.menuList;
        _this.checkDisabled(_this.menuOptions);
        loading.close();
        _this.getTreeId(res.menuList);
        _this.$nextTick(function () {
          _this.menuIds.forEach(function (i, n) {
            var node = _this.$refs.menu.getNode(i);
            if (node.isLeaf) {
              _this.$refs.menu.setChecked(node, true);
            }
          });
        });
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        var roles = _this2.getMenuAllCheckedKeys().toString();
        _this2.pram.rules = roles;
        if (_this2.isCreate === 0) {
          _this2.handlerSave();
        } else {
          _this2.handlerEdit();
        }
      });
    }),
    handlerSave: function handlerSave() {
      var _this3 = this;
      this.loading = true;
      roleApi.addRole(this.pram).then(function (data) {
        _this3.$message.success('创建身份成功');
        _this3.$emit('hideEditDialog');
        _this3.loading = false;
      }).catch(function (res) {
        _this3.loading = false;
      });
    },
    handlerEdit: function handlerEdit() {
      var _this4 = this;
      this.loading = true;
      roleApi.updateRole(this.pram).then(function (data) {
        _this4.$message.success('更新身份成功');
        _this4.$emit('hideEditDialog');
        _this4.loading = false;
      }).catch(function (res) {
        _this4.loading = false;
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand: function handleCheckedTreeExpand(value, type) {
      // this.expandAll = true
      this.expandAll = this.menuExpand ? true : false;
      if (type == 'menu') {
        var treeList = this.menuOptions;
        for (var i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll: function handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : []);
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect: function handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.menuCheckStrictly = value ? true : false;
      }
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys: function getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      var checkedKeys = this.$refs.menu.getCheckedKeys();
      // 半选中的菜单节点
      var halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    getCacheMenu: function getCacheMenu() {
      var _this5 = this;
      if (this.isCreate !== 0) return;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      roleApi.menuCacheList().then(function (res) {
        _this5.menuOptions = res;
        _this5.checkDisabled(_this5.menuOptions);
        loading.close();
      });
    },
    getTreeId: function getTreeId(datas) {
      for (var i in datas) {
        if (datas[i].checked) this.menuIds.push(datas[i].id);
        if (datas[i].childList) {
          this.getTreeId(datas[i].childList);
        }
      }
    },
    checkDisabled: function checkDisabled(data) {
      var _this6 = this;
      //设置公共权限默认勾选且不可操作
      data.forEach(function (item) {
        if (item.id === 179 || item.id === 180) {
          item.disabled = true;
          item.childList.forEach(function (item1) {
            item1.disabled = true;
            _this6.$nextTick(function () {
              var node = _this6.$refs.menu.getNode(item1.id);
              if (node.isLeaf) {
                _this6.$refs.menu.setChecked(node, true);
              }
            });
          });
        }
      });
    }
  }
};